import dealerAddress from './dealerAddress';
import pricing from './pricing';
import incentive from './incentive';
import modal from './modal';
import widgetInfo from './widgetInfo';

const root = {
	dealerAddress,
	pricing,
	incentive,
	modal,
	widgetInfo
};

export default root;



// WEBPACK FOOTER //
// ./src/reducers/index.js